<template>
  <div class="onboarding-container">
    <b-modal id="onboardingModal"
             ref="onboardingModal"
             header-bg-variant="dark" 
             header-text-variant="light" 
             :hide-footer=true
             :hide-header-close=true
             :no-close-on-esc=true
             :no-close-on-backdrop=true
             size="lg"
             :title="modalTitle">
      <b-container fluid>
        <div class="home-video" v-if="currentSlide == 0">
          <!--<b-embed type="iframe"
            aspect="16by9"
            src="https://player.vimeo.com/video/300150849?autoplay=1&muted=1"
            webkitallowfullscreen mozallowfullscreen allowfullscreen
            width="300"
          ></b-embed>-->
          <h2>Bem-vindo ao QUEOTA.club</h2>

        </div>

        <div class="email-container" v-if="currentSlide == 1">
          <h3>Para jogar no QUEOTA.club, você</h3>
          <ul>
            <li v-if="false">Deve estar rodando o nosso anticheat (<a href="/ac/QUEOTA.club.exe" target="_blank">baixe aqui</a>)</li>
            <li>Prometer sempre respeitar os outros jogadores</li>
            <li><a href="https://discord.gg/682TmqAd5U" target="_blank">Entre no discord</a>. Nosso suporte é feito por lá :)</li>
          </ul>
        </div>

        <div class="email-container" v-if="currentSlide == 2">
          <b-form validate ref="onboardingForm" @submit.stop.prevent="onSubmit">
            <b-form-group label="Nickname no jogo"
                          description="Será usado dentro dos servidores (mínimo 3 caracteres)">
              <b-form-input type="text"
                            v-model="form.nickname"
                            autofocus
                            maxlength="25"
                            required>
              </b-form-input>
            </b-form-group>
            <b-form-group label="Seu email"
                          description="Nossa comunicação é feita por email, sem spam.">
              <b-form-input type="email"
                            v-model="form.email"
                            required
                            placeholder="informe seu email aqui">
              </b-form-input>
            </b-form-group>

            <b-form-group label="Sua senha"
                          description="Para acesso ao QUEOTA.club - apenas o primeiro acesso é via Steam :)">
              <b-form-input type="password"
                            v-model="form.password"
                            required
                            placeholder="informe a senha desejada aqui">
              </b-form-input>
            </b-form-group>
            
            <!-- <b-form-group label="Região dos servidores" description="recurso premium">
              <b-form-radio-group v-model="form.server_region" disabled>
                <b-form-radio value="server_nordeste">Norte / Nordeste</b-form-radio>
                <b-form-radio value="server_sudeste">Sul / Sudeste / Centro</b-form-radio>
              </b-form-radio-group>
            </b-form-group> -->

            <div class="actions">
              <b-button type="submit" size="lg" variant="success">Pronto, bora jogar</b-button>
            </div>
          </b-form>
        </div>

        <div class="actions" v-if="currentSlide < 2">
          <b-button @click.stop.prevent="nextSlide" size="lg" variant="success">continuar</b-button>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'Onboarding',
  data () {
    return {
      currentSlide: 1,
      form: {
        nickname: '',
        email: '',
        server_region: 'server_sudeste',
        onboarding_done: true,
        password: ''
      },
      modalTitle: 'Seja bem-vindo ao QUEOTA.club'
    }
  },
  methods: {
    initialize () {
      this.$refs.onboardingModal.show()
      this.form.nickname = this.$store.getters.user.nickname
    },
    nextSlide () {
      this.currentSlide++
      
      if(this.currentSlide == 1) {
        this.modalTitle = ''
      } else if(this.currentSlide == 2) {
        this.modalTitle = 'Último passo, personalize sua conta'
      }
    },
    onSubmit (e) {
      this.$http.put(`users/${this.$store.getters.user.id}.json`, { user: this.form })
              .then(response => {
                this.$store.dispatch('updateUserProfile', response.data)
                this.$notify({
                  group: 'all',
                  title: 'Seja bem-vindo oficialmente ao QUEOTA.club',
                  type: 'success'
                });
                this.$refs.onboardingModal.hide()    
              })
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>

<style lang="sass" scoped>
.actions
  text-align: center
  margin-top: 20px
</style>
